import styled, { css } from 'styled-components'

export const Panel = styled.div(
  ({ theme }) => css`
    background: ${theme.colors.white};
    border-radius: ${theme.border.radius['12']};
    width: 100%;
    max-width: 136rem;
    max-height: 90vh;
    display: flex;
    position: relative;
    padding: ${theme.space['40']};
    gap: ${theme.space['60']};
    overflow: hidden;
  `,
)

export const ContentSection = styled.div(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    width: 38%;
    flex-shrink: 0;
    padding-top: ${theme.space['24']};
  `,
)

export const VideoSection = styled.div(
  ({ theme }) => css`
    flex: 1;
    min-width: 0;
    min-height: 0;
    background: ${theme.colors.gray100};
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    border-radius: ${theme.border.radius['12']};
    overflow: hidden;
  `,
)

export const CloseButton = styled.button(
  ({ theme }) => css`
    position: absolute;
    top: ${theme.space['16']};
    right: ${theme.space['16']};
    background: none;
    border: none;
    cursor: pointer;
    color: ${theme.colors.black500};
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: ${theme.zIndex.level1};

    &:hover {
      color: ${theme.colors.black800};
    }
  `,
)

export const Title = styled.h2(
  ({ theme }) => css`
    font-size: 2.8rem;
    font-weight: 700;
    color: ${theme.colors.black800};
    margin: 0 0 ${theme.space['8']} 0;
  `,
)

export const Description = styled.p(
  ({ theme }) => css`
    font-size: 1.4rem;
    color: ${theme.colors.black500};
    line-height: 1.5;
    margin: 0 0 ${theme.space['24']} 0;
  `,
)

export const HowItWorksHeader = styled.div(
  ({ theme }) => css`
    display: flex;
    align-items: center;
    gap: ${theme.space['8']};
    margin-bottom: ${theme.space['12']};
  `,
)

export const BulletList = styled.ul(
  ({ theme }) => css`
    list-style: none;
    padding: 0;
    margin: 0 0 ${theme.space['32']} 0;
    display: flex;
    flex-direction: column;
    gap: ${theme.space['8']};
  `,
)

export const BulletItem = styled.li(
  ({ theme }) => css`
    font-size: 1.4rem;
    color: ${theme.colors.black600};
    line-height: 1.5;
    padding-left: ${theme.space['12']};
    position: relative;

    &::before {
      content: '·';
      position: absolute;
      left: 0;
      font-weight: 700;
    }
  `,
)

export const PreviewWrapper = styled.div(
  ({ theme }) => css`
    position: relative;
    width: 100%;
    max-height: 100%;
    aspect-ratio: 16 / 9;
    border-radius: ${theme.border.radius['8']};
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;

    &::after {
      content: '';
      position: absolute;
      inset: 0;
      background: color-mix(in srgb, ${theme.colors.black} 20%, transparent);
      pointer-events: none;
    }
  `,
)

export const Video = styled.video`
  display: block;
  width: 100%;
  max-height: 100%;
  height: auto;
  object-fit: contain;
  object-position: center;
`

export const VideoContainer = styled.div`
  display: block;
  width: 100%;
  height: 400px;
`

export const StyledVideo = styled.video`
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
`

export const PlayOverlay = styled.button(
  ({ theme }) => css`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: ${theme.zIndex.level1};
    background: color-mix(in srgb, ${theme.colors.white} 70%, transparent);
    border: none;
    border-radius: ${theme.border.radius.circle};
    width: ${theme.space['64']};
    height: ${theme.space['64']};
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    color: color-mix(in srgb, ${theme.colors.black} 50%, transparent);

    &:hover {
      background: color-mix(in srgb, ${theme.colors.white} 85%, transparent);
    }
  `,
)
